var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsSessionTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.0001,
    r: 36,
    fill: "#E9EDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_88294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.447 21.7967C16.849 22.5915 13.2575 24.0147 13.4225 24.9758L13.4992 25.4222C13.6656 26.3834 17.5271 26.517 22.1252 25.7222C26.7232 24.9275 30.3147 23.5042 30.1497 22.5431L30.073 22.0967C29.9066 21.1356 26.0451 21.0019 21.447 21.7967Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.1259 25.7211C26.7235 24.9261 30.316 23.5032 30.15 22.543C29.984 21.5828 26.1223 21.4488 21.5247 22.2438C16.9271 23.0388 13.3345 24.4616 13.5006 25.4219C13.6666 26.3821 17.5283 26.516 22.1259 25.7211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6885 23.1928C17.5725 23.9051 14.355 25.179 14.5043 26.0392L14.6322 26.7828C14.7815 27.643 18.2393 27.7624 22.3554 27.0515C26.4714 26.3392 29.6889 25.0653 29.5396 24.2051L29.4117 23.4615C29.2624 22.6013 25.8046 22.4819 21.6885 23.1928Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.6322 26.783C14.7815 27.6431 18.2393 27.7626 22.3553 27.0517C26.4714 26.3394 29.6889 25.0654 29.5396 24.2053C29.3903 23.3451 25.9325 23.2256 21.8165 23.9365C17.7004 24.6489 14.4829 25.9228 14.6322 26.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9852 34.479C25.2175 34.0737 25.0426 33.0586 25.6298 32.4202C27.2975 30.6046 29.3165 27.7141 28.8032 24.7483C28.6937 24.1113 25.6269 24.1099 21.9559 24.7454C18.2848 25.381 15.3972 26.4103 15.5067 27.0473C16.0199 30.0146 18.8919 32.0591 21.073 33.2079C21.8407 33.6131 22.0156 34.6282 21.4284 35.2666C19.7607 37.0822 17.7417 39.9727 18.255 42.9386C18.3645 43.5755 21.4313 43.577 25.1023 42.9414C28.7733 42.3059 31.661 41.2765 31.5515 40.6395C31.0382 37.6723 28.1662 35.6278 25.9852 34.479Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.9852 34.479C25.2175 34.0737 25.0426 33.0586 25.6298 32.4202C27.2975 30.6046 29.3165 27.7141 28.8032 24.7483C28.6937 24.1113 25.6269 24.1099 21.9559 24.7454C18.2848 25.381 15.3972 26.4103 15.5067 27.0473C16.0199 30.0146 18.8919 32.0591 21.073 33.2079C21.8407 33.6131 22.0156 34.6282 21.4284 35.2666C19.7607 37.0822 17.7417 39.9727 18.255 42.9386C18.3645 43.5755 21.4313 43.577 25.1023 42.9414C28.7733 42.3059 31.661 41.2765 31.5515 40.6395C31.0382 37.6723 28.1662 35.6278 25.9852 34.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2258 40.8119C31.2912 41.4787 19.4648 43.7806 18.6786 42.7583C18.5421 42.5806 18.4795 42.3204 18.5904 41.9707C18.6487 41.7787 18.7625 41.5612 18.943 41.3152C19.3084 40.8204 20.1132 40.6043 20.6605 40.4039C21.0288 40.2702 21.4013 40.1451 21.771 40.0171C22.1676 39.8792 22.5771 39.9745 22.924 39.6731C23.1316 39.4925 23.2866 39.2238 23.5525 39.1584C23.7487 39.11 23.9605 39.1882 24.1567 39.1356C24.4098 39.0674 24.5904 38.7958 24.852 38.7901C24.9828 38.7873 25.1022 38.8541 25.2302 38.8825C25.4576 38.9309 25.6922 38.8541 25.924 38.8342C26.1529 38.8129 26.3832 38.8498 26.6107 38.884C27.3188 38.9949 28.0297 39.1413 28.7462 39.1783C29.2751 39.2067 29.8581 39.1939 30.3728 39.3389C30.5732 39.3958 30.7538 39.5678 30.896 39.7996H30.8974C31.0694 40.0811 31.1874 40.4479 31.2244 40.8133L31.2258 40.8119Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.3052 39.3688C27.3154 39.3732 27.3067 39.3718 27.2805 39.363C27.2907 39.363 27.298 39.3659 27.3052 39.3688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.8974 39.7978C30.5704 39.5007 29.9661 39.522 29.7927 39.5348C29.6192 39.5476 29.5581 39.3997 29.4273 39.3514C29.2965 39.3045 28.523 39.4026 28.523 39.4026C28.523 39.4026 28.8131 39.458 28.8671 39.5505C28.9154 39.6386 29.251 39.5377 29.2936 39.5249C29.2481 39.5505 28.8543 39.758 28.6666 39.6315C28.4676 39.4978 28.4036 39.7395 28.2557 39.7993C28.1065 39.8604 27.6415 39.7993 27.5662 39.7751C27.4908 39.7509 26.8979 39.7708 26.8979 39.7708C26.8979 39.7708 27.1539 39.6215 27.2776 39.6343C27.4027 39.6486 27.9017 39.3869 27.7993 39.404C27.697 39.4211 27.4638 39.286 27.2818 39.2291C27.1723 39.195 26.8197 39.2405 26.6221 39.2718C26.8624 39.2519 27.1766 39.3358 27.2761 39.3628C27.2079 39.3614 27.0813 39.4268 26.851 39.4978C26.5837 39.5803 26.5951 39.5419 26.4586 39.5661C26.3221 39.5903 26.1942 39.7708 26.1942 39.7708C26.1942 39.7708 25.9596 39.8291 25.6994 39.8561C25.4406 39.8831 25.2145 39.7993 25.2145 39.7993L25.6638 39.6528L25.5103 39.6087C25.3581 39.5647 25.3667 39.5632 25.1861 39.5334C25.0055 39.5035 24.9288 39.6756 24.8847 39.7168C24.8392 39.7595 24.4454 39.7225 24.3345 39.6898C24.2236 39.6557 23.4032 39.9955 23.4032 39.9955L23.915 39.9073C23.915 39.9073 23.9947 39.9585 24.3359 40.0054C24.6785 40.0509 24.7283 39.9372 24.8705 39.9471C25.0126 39.9585 25.4918 40.0865 25.4918 40.0865L25.307 40.1362C25.307 40.1362 25.1022 40.1718 24.815 40.1334C24.5278 40.095 24.3771 40.2457 24.2918 40.2599C24.2065 40.2741 23.7146 40.3765 23.6236 40.3566C23.5326 40.3381 23.288 40.4504 23.1544 40.5869C23.0193 40.7234 22.8217 40.7945 22.5629 40.7277C22.3041 40.6609 21.8677 40.9765 21.8677 40.9765C21.8677 40.9765 22.0966 40.6737 22.216 40.6523C22.3368 40.631 22.7506 40.3836 22.7506 40.3836C22.7506 40.3836 22.6624 40.3822 22.5601 40.3993C22.4563 40.4177 22.3454 40.3836 22.206 40.2841C22.0667 40.186 21.9217 40.2628 21.7113 40.3694C21.5008 40.476 21.2776 40.6026 21.0572 40.4476C20.8354 40.2926 20.1615 40.8642 20.1615 40.8642C20.1615 40.8642 20.5497 40.7632 20.6094 40.7106C20.6719 40.6594 20.716 40.7163 20.9151 40.7519C21.1155 40.786 21.1795 40.6523 21.2762 40.6011C21.3729 40.5485 21.6686 40.6353 21.6686 40.6353C21.6686 40.6353 21.5549 40.6921 21.4468 40.6765C21.3388 40.6594 21.1639 40.9708 21.1056 40.9367C21.0473 40.9011 20.635 40.9566 20.4573 41.049C20.2795 41.14 20.0179 41.45 19.7549 41.3561C19.5317 41.2751 19.0284 41.959 18.5862 41.9675C18.6445 41.7755 18.7582 41.558 18.9388 41.312C19.3042 40.8173 20.1089 40.6012 20.6563 40.4007C21.0245 40.267 21.3971 40.1419 21.7667 40.014C22.1634 39.876 22.5729 39.9713 22.9198 39.6699C23.1274 39.4893 23.2823 39.2206 23.5482 39.1552C23.7444 39.1069 23.9563 39.1851 24.1525 39.1324C24.4055 39.0642 24.5861 38.7926 24.8477 38.787C24.9785 38.7841 25.098 38.8509 25.2259 38.8794C25.4534 38.9277 25.688 38.8509 25.9197 38.831C26.1487 38.8097 26.379 38.8467 26.6065 38.8808C27.3145 38.9917 28.0254 39.1381 28.742 39.1751C29.2709 39.2035 29.8538 39.1907 30.3685 39.3358C30.569 39.3926 30.7495 39.5647 30.8917 39.7964L30.8974 39.7978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7056 40.6382C20.5896 41.3505 17.3721 42.6244 17.5213 43.4846L17.6493 44.2282C17.7986 45.0884 21.2564 45.2078 25.3724 44.4969C29.4885 43.7846 32.706 42.5107 32.5567 41.6505L32.4288 40.9069C32.2795 40.0467 28.8217 39.9273 24.7056 40.6382Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9346 41.9675C20.3365 42.7622 16.7451 44.1854 16.91 45.1466L16.9868 45.593C17.1531 46.5541 21.0147 46.6878 25.6127 45.893C30.2108 45.0982 33.8022 43.675 33.6373 42.7139L33.5605 42.2675C33.3942 41.3063 29.5326 41.1727 24.9346 41.9675Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.6384 46.4006C19.5232 46.3964 19.4137 46.3907 19.3057 46.385C19.4137 46.3907 19.5246 46.3964 19.6384 46.4006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.8669 46.1843C17.9124 46.1957 17.9608 46.2085 18.0091 46.2184C17.9594 46.2071 17.9124 46.1957 17.8669 46.1843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.9346 41.9675C20.3365 42.7622 16.7451 44.1854 16.91 45.1466L16.9868 45.593C16.8204 44.6319 20.4133 43.2087 25.0113 42.4139C29.6094 41.6191 33.4709 41.7528 33.6373 42.7139L33.5605 42.2675C33.3942 41.3063 29.5326 41.1727 24.9346 41.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2322 33.2917C24.1412 34.0012 23.881 35.0789 23.7645 35.7984C23.6479 36.5164 23.9976 37.6296 24.1014 37.9666C24.2052 38.3035 24.9062 38.2495 24.8777 38.5196C24.8507 38.7898 25.9227 38.8339 25.9227 38.8339C25.9227 38.8339 20.8882 40.8229 20.3835 40.6978C19.8787 40.5713 21.3275 39.5775 21.6062 39.5121C21.8849 39.4467 22.037 39.2746 22.2204 38.8765C22.4038 38.4784 22.6014 38.5509 22.7976 38.1514C22.8844 37.9737 23.0905 37.6708 23.2697 37.2287C23.4943 36.6742 23.6863 34.9695 23.4531 34.8259C23.21 34.6766 23.4303 36.1311 23.2299 36.1794C23.0294 36.2277 23.4929 34.7462 22.8801 33.9984C22.2673 33.2505 24.2322 33.2932 24.2322 33.2932V33.2917Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.9242 38.8326C25.9242 38.8326 20.8897 40.8231 20.3849 40.6966C19.92 40.5814 21.1086 39.7284 21.5195 39.5421C21.5465 39.835 22.3356 39.535 22.6484 39.3615C22.9598 39.1881 22.9854 39.3146 23.102 39.2634C23.2171 39.2108 24.0887 38.5611 23.9991 38.5867C23.9081 38.6123 23.2584 39.0928 23.102 38.9379C22.9442 38.7829 22.6868 39.0815 22.4934 39.171C22.3257 39.2506 22.283 39.154 22.1437 39.0331C22.1693 38.9848 22.1963 38.9307 22.2219 38.8725C22.4053 38.4744 22.6029 38.5454 22.7977 38.1459C22.8844 37.9682 23.0906 37.6654 23.2697 37.2232C23.4944 36.6673 23.6877 34.964 23.4532 34.8204C23.21 34.6725 23.4304 36.127 23.2299 36.1739C23.0295 36.2222 23.4915 34.7422 22.8788 33.9929C22.2674 33.245 24.2309 33.2877 24.2309 33.2877C24.1399 33.9986 23.8797 35.0763 23.7631 35.7943C23.6863 36.2649 23.81 36.9033 23.9351 37.3838C23.9024 37.5004 23.8569 37.6071 23.8029 37.6241C23.6735 37.6639 23.5825 38.1047 23.4133 38.1175C23.2456 38.1303 23.3877 38.4416 23.6209 38.3137C23.7759 38.2284 24.0204 38.1758 24.1925 38.0976C24.4114 38.2924 24.9034 38.2895 24.8792 38.5156C24.8522 38.7857 25.9242 38.8312 25.9242 38.8312V38.8326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9634 30.0416C26.9378 30.0829 26.9179 30.1156 26.9037 30.1383C26.7075 30.4895 26.49 30.8307 26.261 31.1591C26.0293 31.4933 25.7862 31.8516 25.489 32.1359C25.216 32.3989 24.9374 32.5212 24.7739 32.8368C24.7369 32.9065 24.7056 32.9876 24.6814 33.0828C24.6217 33.3203 24.6032 33.606 24.3957 33.7397C24.3473 33.7695 24.2919 33.7894 24.2506 33.8278C24.1469 33.9174 24.1525 34.0738 24.1241 34.2074C24.0971 34.3397 23.9677 34.4875 23.8469 34.425C23.7445 34.3724 23.7146 34.1961 23.598 34.2032C23.5682 34.206 23.5412 34.2217 23.5142 34.2288C23.3976 34.2586 23.2895 34.1676 23.1999 34.088C23.1104 34.0098 22.9824 33.933 22.88 33.9942C22.5573 33.6942 22.2203 33.461 21.8649 33.2506C21.5677 33.0714 21.2606 32.9108 20.9393 32.7373C20.2256 32.352 19.4038 31.9696 18.9062 31.5771C18.7242 31.4307 18.5834 31.2857 18.5095 31.1378C18.4796 31.0767 18.4597 31.0155 18.4512 30.9544C18.3701 30.252 20.5426 30.043 21.2962 29.5198C22.0483 28.9966 23.2241 29.3322 23.7175 29.2227C24.2137 29.1132 24.7667 29.2682 25.2871 29.2298C25.8075 29.19 26.1317 29.0407 26.4345 29.2625C26.7359 29.4857 27.0771 29.4175 27.1411 29.5867C27.1795 29.689 27.0501 29.9023 26.962 30.0402L26.9634 30.0416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.3009 29.82C25.8502 29.7332 26.7687 29.7162 26.699 29.6636C26.6308 29.6124 26.4047 29.4389 25.9028 29.456C25.3995 29.473 24.9858 29.4389 24.8792 29.456C24.7725 29.473 25.2275 29.6124 25.2275 29.6124H24.0517C23.6706 29.6124 24.3119 29.456 24.3119 29.456H22.337C22.3896 29.456 22.7707 29.682 22.5446 29.682C22.3185 29.682 22.0768 29.8029 21.7655 29.9237C21.4541 30.046 21.0546 30.1669 21.0034 30.1669C20.9522 30.1669 21.7157 29.5967 21.7626 29.5612C21.7157 29.5811 21.0802 29.8399 20.8129 29.9237C20.5356 30.0105 19.8261 30.2536 19.7565 30.2707C19.6882 30.2877 20.156 30.2707 20.156 30.2707C20.156 30.2707 19.6186 30.5479 19.3427 30.582C19.1351 30.6076 18.6375 30.7797 18.511 31.1394C18.5849 31.2872 18.7257 31.4337 18.9077 31.5787C19.4053 31.9711 20.2271 32.3536 20.9408 32.7389C21.2621 32.9123 21.5692 33.073 21.8664 33.2521C22.2204 33.4626 22.5588 33.6943 22.8816 33.9957C22.9839 33.9346 23.1133 34.01 23.2015 34.0896C23.291 34.1678 23.3991 34.2602 23.5157 34.2303C23.5427 34.2218 23.5697 34.2062 23.5996 34.2047C23.7147 34.1976 23.7446 34.3739 23.8484 34.4265C23.9692 34.4877 24.0972 34.3412 24.1256 34.209C24.1526 34.0754 24.1484 33.919 24.2522 33.8294C24.2948 33.791 24.3488 33.7711 24.3972 33.7412C24.6048 33.609 24.6232 33.3218 24.683 33.0844C24.7071 32.9905 24.7384 32.9081 24.7754 32.8384C24.9389 32.5228 25.2175 32.4005 25.4905 32.1375C25.7877 31.8531 26.0308 31.4948 26.2626 31.1607C26.4929 30.8308 26.7104 30.491 26.9052 30.1399C26.7445 29.8711 26.7531 29.9081 26.3024 29.8214L26.3009 29.82ZM19.8702 31.6555C19.7195 31.6384 20.2072 31.4863 20.2072 31.4863C20.2072 31.4863 20.0906 31.6811 19.8702 31.6555ZM19.9612 31.0711C19.9612 31.0711 20.2086 30.8763 20.3124 30.8891C20.4162 30.9019 20.611 30.8891 20.611 30.8891C20.611 30.8891 20.2214 31.1493 19.9612 31.0711ZM21.9218 32.591C21.7441 32.5583 22.1109 32.4488 22.1977 32.4744C22.2858 32.5 22.1294 32.6308 21.9218 32.591ZM22.7991 30.6034C22.7991 30.6034 22.0455 30.8237 22.1977 30.8237H22.4806C22.428 30.8237 21.6503 30.9929 21.6105 30.9858C21.5707 30.9787 22.074 30.7228 22.074 30.7228C22.074 30.7228 22.0185 30.6531 22.0228 30.6275C22.0271 30.6019 22.1991 30.5493 22.1991 30.5493C22.2602 30.4967 22.5332 30.4199 22.637 30.4839C22.7408 30.5493 23.0138 30.5493 23.0138 30.5493L22.8005 30.6019L22.7991 30.6034ZM23.1161 32.1488C22.9057 31.9569 23.5299 32.1488 23.5299 32.1488C23.5299 32.1488 23.2583 32.2782 23.1161 32.1488ZM23.4531 30.0844C23.7389 29.8896 23.8086 30.0844 23.8086 30.0844C23.8086 30.0844 23.3621 30.147 23.4531 30.0844ZM24.4384 30.8379C24.3631 30.7996 24.2195 30.7256 24.2195 30.7256C24.2195 30.7256 24.4 30.619 24.518 30.6176C24.7142 30.6147 24.8422 30.6773 24.9204 30.7256C24.9986 30.774 24.5138 30.8778 24.4384 30.8379ZM24.9986 31.792C24.9986 31.792 24.6474 31.7849 24.6147 31.792C24.5806 31.7991 24.8564 31.6939 24.9986 31.6569V31.792ZM25.5417 30.3872C25.5417 30.3872 25.7905 30.3332 25.9071 30.4626C26.0649 30.6361 25.5417 30.3872 25.5417 30.3872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8485 50.4385L47.9944 50.784H54.2617L54.3996 48.2731L53.1882 47.7542C53.1882 47.7542 53.4128 45.8134 53.7768 43.7333L54.6086 43.7078L56.3744 36.7439L55.3706 36.3102L56.0972 34.0027H57.1877L58.3507 30.7652C58.3507 30.7652 54.1721 29.0989 51.6811 28.8785L49.4489 29.2525L49.2925 32.1586L47.4741 32.3989L47.1158 35.5311L48.4082 35.7529L47.5778 42.4068L45.7096 42.9329L45.384 47.5139L47.0106 47.848L46.847 50.4385H46.8485Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.0959 34.0013L55.368 36.3074L56.3717 36.7425L54.6045 43.7064L53.7727 43.732C53.4087 45.8121 53.1841 47.7514 53.1841 47.7514L54.3955 48.2718L54.2576 50.7826H47.9903L46.8444 50.4371L47.0079 47.8452L45.3813 47.5111L45.6984 43.041L45.7069 42.9301L47.5752 42.4055L48.4069 35.7515L47.1131 35.5297L47.4714 32.3975L49.2884 32.1573L49.4448 29.2525L51.677 28.8772C54.168 29.099 58.3466 30.7639 58.3466 30.7639L57.1836 34.0013H56.0945H56.0959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.3981 48.2715L48.2006 48.445L47.012 47.8464L48.374 48.0981L53.1868 47.7526L54.3981 48.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.7755 43.732L49.2926 43.7462L45.7026 43.0438L45.7112 42.9315L47.578 42.4069L49.5514 43.5898L53.7755 43.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.3692 36.3088L49.8384 35.7671L48.4095 35.7529L47.1157 35.5311L49.7588 35.2283L55.3692 36.3088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.1865 34.0011H56.096L51.7325 32.0078L49.2927 32.1585L51.8662 31.8258L57.1865 34.0011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.6799 28.8772L51.8662 31.826L49.2927 32.1587L49.4477 29.2525L51.6799 28.8772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.7588 35.2282L50.4697 32.1586L47.4754 32.3988L47.1157 35.531L49.7588 35.2282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.4096 35.7528L51.1181 35.8921L49.5513 43.5897L47.5779 42.4068L48.4096 35.7528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.7026 43.0439L49.2926 43.7463L48.5675 48.0856L45.3855 47.514L45.7026 43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.2007 48.4453L47.9931 50.7841L46.8472 50.4386L47.0107 47.8481L48.2007 48.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9756 44.0133L49.1277 44.7313L52.8414 44.5678L49.2926 45.364L45.9756 44.0133Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9636 48.6031L48.1238 49.3155H50.9276L47.5238 49.5884L46.3835 48.8093L46.9636 48.6031Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3479 50.0089H54.3028L54.8744 50.4383L49.3479 50.0089Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3315 45.8747L45.5562 45.0984L45.0586 45.3643L48.3315 45.8747Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1619 46.9652L53.3334 46.6069L53.7756 46.7861L49.1619 46.9652Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4697 42.407L54.9768 42.2449L55.3692 42.5761L50.4697 42.407Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7754 41.4599L50.0702 41.039L47.7854 40.1874H47.012L49.7389 41.3305L53.7754 41.4599Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6555 38.136L50.5252 38.8085L56.3559 39.2791L55.8284 38.8881L50.4697 38.5511L48.6555 38.136Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2927 34.2402L46.6951 34.371L47.3391 34.6824L49.2927 34.2402Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2007 33.1766L50.1755 32.9136L55.2641 34.6823L50.1485 33.3572L48.2007 33.1766Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5121 32.1587L51.4737 30.5179L48.4609 31.462L49.3481 31.7009L51.8661 31.3383L54.5121 32.1587Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5764 31.0211L58.1475 32.9135H57.5773L53.5764 31.0211Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1218 29.5922L54.4066 29.8523L57.9668 31.8258C57.9668 31.8258 53.3687 29.8253 52.1218 29.5922Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2788 36.6047L49.4077 36.8891L47.8125 36.7469L48.2788 36.6047Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M45.9756 44.0133L49.1277 44.7313L52.8414 44.5678L49.2926 45.364L45.9756 44.0133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.9636 48.6031L48.1238 49.3155H50.9276L47.5238 49.5884L46.3835 48.8093L46.9636 48.6031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.3479 50.0089H54.3028L54.8744 50.4383L49.3479 50.0089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.3315 45.8747L45.5562 45.0984L45.0586 45.3643L48.3315 45.8747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.1619 46.9652L53.3334 46.6069L53.7756 46.7861L49.1619 46.9652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.4697 42.407L54.9768 42.2449L55.3692 42.5761L50.4697 42.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.7754 41.4599L50.0702 41.039L47.7854 40.1874H47.012L49.7389 41.3305L53.7754 41.4599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.6555 38.136L50.5252 38.8085L56.3559 39.2791L55.8284 38.8881L50.4697 38.5511L48.6555 38.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.2927 34.2402L46.6951 34.371L47.3391 34.6824L49.2927 34.2402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.2007 33.1766L50.1755 32.9136L55.2641 34.6823L50.1485 33.3572L48.2007 33.1766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.5121 32.1587L51.4737 30.5179L48.4609 31.462L49.3481 31.7009L51.8661 31.3383L54.5121 32.1587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.5764 31.0211L58.1475 32.9135H57.5773L53.5764 31.0211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.1218 29.5922L54.4066 29.8523L57.9668 31.8258C57.9668 31.8258 53.3687 29.8253 52.1218 29.5922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.2788 36.6047L49.4077 36.8891L47.8125 36.7469L48.2788 36.6047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.1619 37.3312L50.7059 37.7207L55.0452 38.1359L50.7059 37.9226L49.1619 37.3312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.6555 36.1879L51.118 36.3087L55.7317 37.0978L50.973 36.6044L48.6555 36.1879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.9932 34.8118L49.9268 34.5076L54.8234 35.6436L49.8856 34.6824L47.9932 34.8118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.4609 33.8449L50.0903 33.798L55.0452 35.0747L50.0434 34.0013L48.4609 33.8449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.416 32.9136L49.8899 32.6306L47.416 33.0984V32.9136Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.3391 33.5875H48.2007L47.3391 33.798V33.5875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.4077 29.9931L51.7252 29.5922L54.8233 30.7097L51.7537 29.8523L49.4077 30.1509V29.9931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.3969 33.4141L53.8623 32.3108L57.2973 33.6928L57.3969 33.4141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.2432 30.2675L51.7607 30.1509L57.3966 31.9665L51.7849 30.3371L51.2432 30.2675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.2568 31.0212L56.2336 30.3018L58.1474 31.2017L58.2568 31.0212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.2007 38.9403L50.3632 39.6014L55.2641 39.9967L50.3163 39.8303L48.2007 38.9403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.7341 40.9836L49.9109 41.8239L54.8231 41.9362H49.8881L47.7341 40.9836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.932 43.2513L49.7391 42.785L47.9932 42.0741L49.6638 43.0438L53.932 43.2513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.3906 40.6166C55.3522 40.6024 52.011 40.5156 52.011 40.5156L55.338 40.8227L55.3906 40.6166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.6387 43.3722L49.223 44.1556H51.7324L49.1974 44.3091L45.7027 43.5897L45.6387 43.3722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.5394 45.1736C53.5394 45.1807 50.0532 45.5632 50.0532 45.5632L53.5096 45.3684L53.5394 45.1736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.3835 44.9306C46.3366 44.9079 48.5475 45.3685 48.5475 45.3685C48.5475 45.3685 47.1712 45.3245 46.3835 44.9306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.5007 45.8746L48.5476 46.6069L45.5007 46.1078V45.8746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.072 46.9651L48.6554 47.5537L52.5056 47.4755L48.6554 47.7528L46.072 46.9651Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.5684 46.2412H52.2698L50.0532 46.3507L49.5684 46.2412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.3391 48.4452L48.1694 48.8077C48.1694 48.8077 52.5869 48.7722 52.5059 48.8077C52.4263 48.8433 48.1524 48.9997 48.1524 48.9997L47.3391 48.4452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.7754 49.5881C53.7754 49.5881 49.6494 49.6919 49.739 49.6919H53.1527L53.7754 49.5881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.3981 48.7226C54.3981 48.7226 53.7213 48.6529 53.7739 48.7226C53.8265 48.7923 54.364 48.8804 54.364 48.8804L54.3966 48.7226H54.3981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.3391 50.0089L48.0486 50.1568L51.8675 50.4383L48.0329 50.3473L47.3391 50.0089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7729 25.9483L49.6791 24.8137C49.6791 24.8137 52.9705 26.7402 55.0648 27.0587L51.4449 27.771C51.4449 27.771 47.5251 26.9905 46.7729 25.9483Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1758 35.281L31.3838 33.2891C31.3838 33.2891 35.1558 33.862 38.0989 35.281L35.025 37.1677C35.025 37.1677 32.1302 35.6961 29.1772 35.281H29.1758Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4873 37.8245L14.3223 36.8463C14.3223 36.8463 16.782 39.4752 18.7427 39.4766L15.4911 41.0363C15.4911 41.0363 12.0276 39.7098 11.4873 37.8245Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.364 27.974C22.364 27.974 26.0635 27.5418 28.6867 29.5835L27.3346 31.2484C27.3346 31.2484 24.0872 29.8735 21.2437 30.6783L22.364 27.9726V27.974Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7361 43.5231L59.302 44.1316C59.302 44.1316 56.2082 46.1847 53.602 46.5628L50.7883 45.6515C50.7883 45.6515 54.175 45.2975 55.7361 43.5231Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6042 37.3484C54.6042 37.3484 58.0322 37.1635 60.4563 38.1687L61.9108 36.7796C61.9108 36.7796 58.1047 35.1119 55.6521 35.9451L54.6042 37.3469V37.3484Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1733 50.4556C31.1733 50.4556 32.888 48.6528 37.1647 48.1765L39.7581 49.3452C39.7581 49.3452 35.8894 50.1841 34.1292 51.0016L31.1733 50.4556Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.7729 25.9483L49.6791 24.8137C49.6791 24.8137 52.9705 26.7402 55.0648 27.0587L51.4449 27.771C51.4449 27.771 47.5251 26.9905 46.7729 25.9483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.1758 35.281L31.3838 33.2891C31.3838 33.2891 35.1558 33.862 38.0989 35.281L35.025 37.1677C35.025 37.1677 32.1302 35.6961 29.1772 35.281H29.1758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.4873 37.8245L14.3223 36.8463C14.3223 36.8463 16.782 39.4752 18.7427 39.4766L15.4911 41.0363C15.4911 41.0363 12.0276 39.7098 11.4873 37.8245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.364 27.974C22.364 27.974 26.0635 27.5418 28.6867 29.5835L27.3346 31.2484C27.3346 31.2484 24.0872 29.8735 21.2437 30.6783L22.364 27.9726V27.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M55.7361 43.5231L59.302 44.1316C59.302 44.1316 56.2082 46.1847 53.602 46.5628L50.7883 45.6515C50.7883 45.6515 54.175 45.2975 55.7361 43.5231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.6042 37.3484C54.6042 37.3484 58.0322 37.1635 60.4563 38.1687L61.9108 36.7796C61.9108 36.7796 58.1047 35.1119 55.6521 35.9451L54.6042 37.3469V37.3484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.1733 50.4556C31.1733 50.4556 32.888 48.6528 37.1647 48.1765L39.7581 49.3452C39.7581 49.3452 35.8894 50.1841 34.1292 51.0016L31.1733 50.4556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_88294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 30,
    fill: "white",
    transform: "translate(11 21.0001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsSessionTime);
export default __webpack_public_path__ + "static/media/AnalyticsSessionTime.7ee8ee9856693f04717b69cb53b27437.svg";
export { ForwardRef as ReactComponent };